import { render, staticRenderFns } from "./linkin.vue?vue&type=template&id=c4dd355a&scoped=true"
import script from "./linkin.vue?vue&type=script&lang=js"
export * from "./linkin.vue?vue&type=script&lang=js"
import style0 from "./linkin.vue?vue&type=style&index=0&id=c4dd355a&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4dd355a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/saas_fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c4dd355a')) {
      api.createRecord('c4dd355a', component.options)
    } else {
      api.reload('c4dd355a', component.options)
    }
    module.hot.accept("./linkin.vue?vue&type=template&id=c4dd355a&scoped=true", function () {
      api.rerender('c4dd355a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sales/salesReps/linkin.vue"
export default component.exports